<div class="product-images-wrapper">
  <ng-container>
    <div class="main-image">
      <cx-media
        format="zoom"
        class="is-initialized is-missing"
        [class.is-missing-fish]="businessType === 'fish'"
        removeImageTitleAttr
      >
      </cx-media>
    </div>
  </ng-container>
  @if (newThumbs$; as thumbs) { @if (thumbs.length) {
  <div class="gallery-images">
    <ngx-slick-carousel class="carousel" #slickModal="slick-carousel" [config]="slickConfig">
      @for (item of thumbs; track item) {
      <div ngxSlickItem class="slide">
        @if (item | async; as items) {
        <div class="gallery">
          @if (items; as data) { @if (data?.container?.product) {
          <cx-media
            [container]="getImageRendition(data?.container, 'secondary')"
            tabindex="0"
            format="product"
            (focus)="openImages(data?.container, false)"
            [class.is-active]="isActivePrimary(data?.container) | async"
            [class.is-missing-fish]="businessType === 'fish'"
            removeImageTitleAttr
          >
          </cx-media>
          } @if (data?.container?.gallery) {
          <cx-media
            [container]="getImageRendition(data?.container, 'secondary')"
            tabindex="0"
            format="gallery"
            (focus)="openImages(data?.container, true)"
            [class.is-active]="isActive(data?.container) | async"
            [class.is-missing-fish]="businessType === 'fish'"
            removeImageTitleAttr
          >
          </cx-media>
          } }
        </div>
        }
      </div>
      }
    </ngx-slick-carousel>
  </div>
  } }
</div>
